<template>
  <button
      v-bind:class="[ active ? 'bg-green-700 text-green-100' : 'bg-green-50 text-green-900 hover:bg-green-200' ]"
      class="outline-none py-1 px-3 border-0 flex justify-between rounded-full transition-all transform hover:scale-105">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "EditorButton",

  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>